import { TreeItem, ItemType, TreeItemCheckedType } from './item';
import { DossierTree } from './tree';
import { RecordLink } from '../../record-link/record-link';
import { DataLink } from '../../data-link/data-link';
import { DataItem } from './data-item';
import { RecordItem } from './record-item';
import { each, filter } from 'lodash';



export class SimpleItem extends TreeItem {

  target: any

  constructor(target: any, parent: TreeItem, tree: DossierTree) {
    super(parent, tree);
    this.target = target;

    each(tree.dossier.links, l => {

      if (l.name === target.id) {
        if (l.isRecordLink()) {
          let item = new RecordItem(l as RecordLink, this, tree);

          this.addChild(item);
        }
        else if (l.isDataLink()) {
          let item = new DataItem(l as DataLink, this, tree);

          this.addChild(item);
        }
      }
    });
  }

  addChild(item: TreeItem) {
    super.addChild(item);

    this.children.sort(TreeItem.sortByLabel);
  }

  get type(): ItemType {
    return 'SIMPLE';
  }

  get label(): string {
    return this.target.text + ' (' + this.children.length + ')';
  }

  get checked(): TreeItemCheckedType {
    if(this.children.length === 0) {
      return 'DISABLED';
    }

    let checked = filter(this.children, child => child.checked === 'YES');

    if(checked.length === this.children.length) {
      return 'YES';
    }
    else if(checked.length === 0) {
      return 'NO';
    }
    else {
      return 'INDETERMINATE';
    }
  }

  set checked(value: TreeItemCheckedType) {
    each(this.children, child => child.checked = value);
  }
}